import Bowser from "bowser";
import * as DeviceDetect from "react-device-detect";
export * from "react-device-detect";
export const bowser = Bowser.getParser(navigator.userAgent);
export const osName = DeviceDetect.osName;
export const osVersion = DeviceDetect.osVersion;
export const browserName = DeviceDetect.browserName;
export const browserVersion = DeviceDetect.browserVersion;
//# sourceMappingURL=userAgent.js.map